import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { CredentialProperties } from './credential-properties';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.managedIdentityCredentialProperties
})
export class ManagedIdentityCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;
}
